import ImagePreview from './ImagePreview';

export default ImagePreview;
export * from './types';

export { ImagePreview };
